"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import type { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { ApiProfileRepRatesState } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { commonApiFetch } from "@/services/api/common-api";
import { RateMatter } from "@/types/enums";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "next/navigation";
import { useContext, useEffect, useState } from "react";
import UserPageIdentityHeader from "../identity/header/UserPageIdentityHeader";
import UserPageIdentityHeaderCICRate from "../identity/header/cic-rate/UserPageIdentityHeaderCICRate";
import UserPageIdentityStatements from "../identity/statements/UserPageIdentityStatements";
import UserPageRateWrapper from "../utils/rate/UserPageRateWrapper";
import UserPageCombinedActivityLog from "./UserPageCombinedActivityLog";
import UserPageRepHeader from "./header/UserPageRepHeader";
import UserPageRepMobile from "./UserPageRepMobile";
import UserPageRepReps from "./reps/UserPageRepReps";
export default function UserPageRep(t0) {
  const $ = _c(53);
  const {
    profile,
    initialActivityLogParams
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const params = useParams();
  let t1;
  if ($[0] !== params?.user) {
    t1 = (params?.user as string)?.toLowerCase();
    $[0] = params?.user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const user = t1;
  const [rater, setRater] = useState(undefined);
  let t2;
  if ($[2] !== connectedProfile?.handle) {
    t2 = () => setRater(connectedProfile?.handle?.toLowerCase());
    $[2] = connectedProfile?.handle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== connectedProfile) {
    t3 = [connectedProfile];
    $[4] = connectedProfile;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[6] !== rater || $[7] !== user) {
    t4 = [QueryKey.PROFILE_REP_RATINGS, {
      rater,
      handleOrWallet: user
    }];
    t5 = async () => await commonApiFetch({
      endpoint: `profiles/${user}/rep/ratings/received`,
      params: rater ? {
        rater
      } : {}
    });
    $[6] = rater;
    $[7] = user;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  const t6 = !!user;
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = {
      queryKey: t4,
      queryFn: t5,
      enabled: t6
    };
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const {
    data: repRates
  } = useQuery(t7);
  const t8 = repRates ?? null;
  let t9;
  if ($[14] !== initialActivityLogParams || $[15] !== profile || $[16] !== t8) {
    t9 = <UserPageRepMobile profile={profile} repRates={t8} initialActivityLogParams={initialActivityLogParams} />;
    $[14] = initialActivityLogParams;
    $[15] = profile;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = repRates ?? null;
  let t11;
  if ($[18] !== profile || $[19] !== t10) {
    t11 = <UserPageRepHeader repRates={t10} profile={profile} />;
    $[18] = profile;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = repRates ?? null;
  let t13;
  if ($[21] !== profile || $[22] !== t12) {
    t13 = <UserPageRepReps repRates={t12} profile={profile} />;
    $[21] = profile;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== initialActivityLogParams) {
    t14 = <div className="tw-mt-6 lg:tw-mt-8"><UserPageCombinedActivityLog initialActivityLogParams={initialActivityLogParams} /></div>;
    $[24] = initialActivityLogParams;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t11 || $[27] !== t13 || $[28] !== t14) {
    t15 = <div className="tw-min-w-0">{t11}{t13}{t14}</div>;
    $[26] = t11;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-emerald-500/[0.05] tw-via-transparent tw-to-transparent" />;
    t17 = <div className="tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-h-px tw-bg-gradient-to-r tw-from-transparent tw-via-emerald-400/25 tw-to-transparent" />;
    t18 = <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-px tw-bg-gradient-to-r tw-from-transparent tw-via-emerald-400/40 tw-to-transparent" />;
    t19 = <div className="tw-absolute tw-bottom-0 tw-left-0 tw-top-0 tw-w-px tw-bg-gradient-to-b tw-from-transparent tw-via-emerald-400/20 tw-to-transparent" />;
    t20 = <div className="tw-absolute tw-bottom-0 tw-right-0 tw-top-0 tw-w-px tw-bg-gradient-to-b tw-from-transparent tw-via-emerald-400/20 tw-to-transparent" />;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
    $[33] = t19;
    $[34] = t20;
  } else {
    t16 = $[30];
    t17 = $[31];
    t18 = $[32];
    t19 = $[33];
    t20 = $[34];
  }
  let t21;
  let t22;
  if ($[35] !== profile) {
    t21 = <UserPageIdentityHeader profile={profile} />;
    t22 = <UserPageIdentityStatements profile={profile} />;
    $[35] = profile;
    $[36] = t21;
    $[37] = t22;
  } else {
    t21 = $[36];
    t22 = $[37];
  }
  let t23;
  if ($[38] !== profile) {
    t23 = <UserPageIdentityHeaderCICRate profile={profile} isTooltip={false} />;
    $[38] = profile;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] !== profile || $[41] !== t23) {
    t24 = <div className="tw-px-6 tw-pb-8"><UserPageRateWrapper profile={profile} type={RateMatter.NIC} hideOwnProfileMessage={true}>{t23}</UserPageRateWrapper></div>;
    $[40] = profile;
    $[41] = t23;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== t21 || $[44] !== t22 || $[45] !== t24) {
    t25 = <div className="tw-min-w-0 tw-self-start"><div className="tw-relative tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-white/[0.08] tw-bg-[#08090b]">{t16}{t17}{t18}{t19}{t20}<div className="tw-relative tw-z-10">{t21}{t22}{t24}</div></div></div>;
    $[43] = t21;
    $[44] = t22;
    $[45] = t24;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t15 || $[48] !== t25) {
    t26 = <div className="tw-hidden lg:tw-block"><div className="tw-grid tw-grid-cols-1 tw-gap-x-8 lg:tw-grid-cols-[minmax(0,2fr)_minmax(22rem,1fr)] xl:tw-gap-x-10">{t15}{t25}</div></div>;
    $[47] = t15;
    $[48] = t25;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== t26 || $[51] !== t9) {
    t27 = <div className="tailwind-scope">{t9}{t26}</div>;
    $[50] = t26;
    $[51] = t9;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  return t27;
}